window.car_make_model_data = [
    {
        "Car Make-Model": "Abarth-500e",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Abarth-595",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Abarth-695",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Acura-ILX",
        "Year Range": "2019-2022"
    },
    {
        "Car Make-Model": "Acura-Integra",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Acura-MDX",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Acura-NSX",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Acura-RDX",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Acura-TLX",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Acura-ZDX",
        "Year Range": "2024"
    },
    {
        "Car Make-Model": "Alfa Romeo-Giulia",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Alfa Romeo-Stelvio",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Alfa Romeo-Tonale",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Alpine-A110",
        "Year Range": "2021-2024"
    },
    {
        "Car Make-Model": "Aston Martin-DB9 Volante",
        "Year Range": "2017"
    },
    {
        "Car Make-Model": "Aston Martin-DBX",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Aston Martin-Rapide",
        "Year Range": "2017-2018"
    },
    {
        "Car Make-Model": "Aston Martin-V12 Vantage",
        "Year Range": "2017"
    },
    {
        "Car Make-Model": "Aston Martin-V8 Vantage",
        "Year Range": "2017"
    },
    {
        "Car Make-Model": "Aston Martin-Vanquish",
        "Year Range": "2017-2018"
    },
    {
        "Car Make-Model": "Audi-A1",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Audi-A3",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Audi-A4",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Audi-A5",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Audi-A6",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Audi-A7",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Audi-A8",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Audi-Q2",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Audi-Q3",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Audi-Q4 Sportback e\u2011tron",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Audi-Q4 e\u2011tron",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Audi-Q5",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Audi-Q7",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Audi-Q8",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Audi-Q8 Sportback e\u2011tron",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Audi-Q8 e\u2011tron",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Audi-R8",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Audi-TT",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Audi-e\u2011tron",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Audi-e\u2011tron GT",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Audi-e\u2011tron Sportback",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "BMW-1 Series",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "BMW-2 Series",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "BMW-3 Series",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "BMW-4 Series",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "BMW-5 Series",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "BMW-6 Series",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "BMW-7 Series",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "BMW-8 Series",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "BMW-X1",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "BMW-X2",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "BMW-X3",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "BMW-X4",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "BMW-X5",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "BMW-X5 M",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "BMW-X6",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "BMW-X6 M",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "BMW-X7",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "BMW-Z4",
        "Year Range": "2019-2022"
    },
    {
        "Car Make-Model": "BYD-ATTO3",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "BYD-CHAZOR",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "BYD-DOLPHIN",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "BYD-HALO6",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "BYD-HAN",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "BYD-QIN PLUS",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "BYD-SEAGULL",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "BYD-SEAL",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "BYD-SEAL U",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "BYD-SONG PLUS",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "BYD-TANG",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "BYD-YUAN PLUS",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Baojun -310",
        "Year Range": "2018"
    },
    {
        "Car Make-Model": "Baojun-310",
        "Year Range": "2019-2022"
    },
    {
        "Car Make-Model": "Baojun-310C",
        "Year Range": "2022-2024"
    },
    {
        "Car Make-Model": "Baojun-310W",
        "Year Range": "2018-2022"
    },
    {
        "Car Make-Model": "Baojun-510",
        "Year Range": "2018-2022"
    },
    {
        "Car Make-Model": "Baojun-530",
        "Year Range": "2022-2025"
    },
    {
        "Car Make-Model": "Baojun-730",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Bentley-Bentayga",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Bentley-Continental",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Bentley-Flying Spur",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Borgward-BX3",
        "Year Range": "2018-2020"
    },
    {
        "Car Make-Model": "Borgward-BX4",
        "Year Range": "2018-2020"
    },
    {
        "Car Make-Model": "Borgward-BX5",
        "Year Range": "2018-2020"
    },
    {
        "Car Make-Model": "Borgward-BX6",
        "Year Range": "2020"
    },
    {
        "Car Make-Model": "Buick-Enclave",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Buick-Encore",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Buick-Encore GX",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Buick-Envision",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Buick-Envista",
        "Year Range": "2024"
    },
    {
        "Car Make-Model": "Buick-Excelle",
        "Year Range": "2016-2017"
    },
    {
        "Car Make-Model": "Buick-GL6",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Buick-GL8 Avenir",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Buick-GL8 Business Travel Edition",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Buick-GL8 ES",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Buick-GT",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Buick-GT-MPV",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Buick-LaCrosse",
        "Year Range": "2016-2022"
    },
    {
        "Car Make-Model": "Buick-Regal",
        "Year Range": "2016-2022"
    },
    {
        "Car Make-Model": "Buick-VELITE 6",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Cadillac-ATS",
        "Year Range": "2016-2019"
    },
    {
        "Car Make-Model": "Cadillac-ATS-V",
        "Year Range": "2016-2019"
    },
    {
        "Car Make-Model": "Cadillac-CT4",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Cadillac-CT4-V",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Cadillac-CT4-V Blackwing",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Cadillac-CT5",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Cadillac-CT5-V",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Cadillac-CT5-V Blackwing",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Cadillac-CT6",
        "Year Range": "2016-2022"
    },
    {
        "Car Make-Model": "Cadillac-CT6-V",
        "Year Range": "2016-2022"
    },
    {
        "Car Make-Model": "Cadillac-CTS",
        "Year Range": "2016-2019"
    },
    {
        "Car Make-Model": "Cadillac-CTS-V",
        "Year Range": "2016-2019"
    },
    {
        "Car Make-Model": "Cadillac-ELR",
        "Year Range": "2016"
    },
    {
        "Car Make-Model": "Cadillac-Escalade / ESV",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Cadillac-Escalade-V",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Cadillac-LYRIQ",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Cadillac-XT4",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Cadillac-XT5",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Cadillac-XT6",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Cadillac-XTS",
        "Year Range": "2016-2019"
    },
    {
        "Car Make-Model": "Chery-Arrizo 5",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Chery-Arrizo 6",
        "Year Range": "2020-2022"
    },
    {
        "Car Make-Model": "Chery-Arrizo 7",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Chery-Tiggo 2",
        "Year Range": "2018-2022"
    },
    {
        "Car Make-Model": "Chery-Tiggo 3",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Chery-Tiggo 3X",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Chery-Tiggo 4",
        "Year Range": "2018-2022"
    },
    {
        "Car Make-Model": "Chery-Tiggo 5X",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Chery-Tiggo 8",
        "Year Range": "2018-2022"
    },
    {
        "Car Make-Model": "Chevrolet-Aveo",
        "Year Range": "2017-2019"
    },
    {
        "Car Make-Model": "Chevrolet-Blazer",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Bolt EUV",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Bolt EV",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Camaro",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Camaro Convertible",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Captiva",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Cavalier",
        "Year Range": "2016-2017"
    },
    {
        "Car Make-Model": "Chevrolet-Colorado",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Corvette",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Corvette Convertible",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Cruze",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Equinox",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Impala",
        "Year Range": "2016-2019"
    },
    {
        "Car Make-Model": "Chevrolet-Malibu",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Monza",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Prisma",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Chevrolet-S10",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Chevrolet-Sail LOVA",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Silverado",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Silverado HD",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Sonic",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Chevrolet-Spark",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Suburban",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Tahoe",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Tracker",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Chevrolet-Trailblazer",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Traverse",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Chevrolet-Trax",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Chevrolet-Volt",
        "Year Range": "2016-2019"
    },
    {
        "Car Make-Model": "Chrysler-300",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Chrysler-Pacifica",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Chrysler-Voyager",
        "Year Range": "2020-2021"
    },
    {
        "Car Make-Model": "Citroen-Aircross",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Citroen-Berlingo",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Citroen-Berlingo Multispace",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Citroen-C-Elys\u00e9e",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Citroen-C-Quatre",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Citroen-C3",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Citroen-C3-AirCross",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Citroen-C3-XR",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Citroen-C4",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Citroen-C4 Cactus",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Citroen-C4 Picasso",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Citroen-C4 Spacetourer",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Citroen-C4-L",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Citroen-C4-Lounge",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Citroen-C5",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Citroen-C5 Aircross",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Citroen-C5 Break",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Citroen-C6",
        "Year Range": "2016-2022"
    },
    {
        "Car Make-Model": "Citroen-Jumper",
        "Year Range": "2016-2022"
    },
    {
        "Car Make-Model": "Citroen-Jumpy",
        "Year Range": "2016-2022"
    },
    {
        "Car Make-Model": "Citroen-Spacetourer",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Cowin Auto-E3",
        "Year Range": "2017-2021"
    },
    {
        "Car Make-Model": "Cupra-Ateca",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Cupra-Born",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Cupra-Formentor",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Cupra-Leon",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "DS-DS 3",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "DS-DS 3 Cabrio",
        "Year Range": "2016-2022"
    },
    {
        "Car Make-Model": "DS-DS 3 Crossback",
        "Year Range": "2016-2022"
    },
    {
        "Car Make-Model": "DS-DS 4",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "DS-DS 5",
        "Year Range": "2016-2022"
    },
    {
        "Car Make-Model": "DS-DS 6",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "DS-DS 7",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "DS-DS 9",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Dacia-Duster",
        "Year Range": "2021-2024"
    },
    {
        "Car Make-Model": "Dacia-Jogger",
        "Year Range": "2022-2024"
    },
    {
        "Car Make-Model": "Dacia-Logan",
        "Year Range": "2020-2024"
    },
    {
        "Car Make-Model": "Dacia-Sandero",
        "Year Range": "2020-2024"
    },
    {
        "Car Make-Model": "Dacia-Sandero Stepway",
        "Year Range": "2020-2024"
    },
    {
        "Car Make-Model": "Dacia-Spring",
        "Year Range": "2019-2024"
    },
    {
        "Car Make-Model": "Datsun-GO",
        "Year Range": "2019-2022"
    },
    {
        "Car Make-Model": "Datsun-GO+",
        "Year Range": "2019-2022"
    },
    {
        "Car Make-Model": "Dodge-Challenger",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Dodge-Charger",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Dodge-Durango",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Dodge-Hornet",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Dodge-Journey",
        "Year Range": "2019-2021"
    },
    {
        "Car Make-Model": "Exeed-Exeed LX",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Exeed-Exeed TXL",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Exeed-Exeed VX",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Ferrari-296 GTB",
        "Year Range": "2022"
    },
    {
        "Car Make-Model": "Ferrari-296 GTS",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Ferrari-488 GTB",
        "Year Range": "2016-2017"
    },
    {
        "Car Make-Model": "Ferrari-488 Spider",
        "Year Range": "2016-2017"
    },
    {
        "Car Make-Model": "Ferrari-812 GTS",
        "Year Range": "2021"
    },
    {
        "Car Make-Model": "Ferrari-812 Superfast",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Ferrari-California T",
        "Year Range": "2016-2017"
    },
    {
        "Car Make-Model": "Ferrari-Daytona SP3",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Ferrari-F12 Berlinetta",
        "Year Range": "2016-2017"
    },
    {
        "Car Make-Model": "Ferrari-F12 tdf",
        "Year Range": "2016"
    },
    {
        "Car Make-Model": "Ferrari-F8 Spider",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Ferrari-F8 Tributo",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Ferrari-FF",
        "Year Range": "2016"
    },
    {
        "Car Make-Model": "Ferrari-GTC4Lusso",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Ferrari-Monza SP1",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Ferrari-Monza SP2",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Ferrari-Portofino",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Ferrari-Purosangue",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Ferrari-Roma",
        "Year Range": "2021"
    },
    {
        "Car Make-Model": "Ferrari-SF90 Spider",
        "Year Range": "2021"
    },
    {
        "Car Make-Model": "Ferrari-SF90 Stradale",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Fiat-500",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Fiat-500L",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Fiat-500X",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Fiat-600e",
        "Year Range": "2024"
    },
    {
        "Car Make-Model": "Fiat-Argo",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Fiat-E-Dobl\u00f2",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Fiat-Panda",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Fiat-Tipo",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Ford-Bronco",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Ford-Bronco Sport",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Ford-C-MAX",
        "Year Range": "2017-2019"
    },
    {
        "Car Make-Model": "Ford-E-Transit",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Ford-EcoSport",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Ford-Edge",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Ford-Escape",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Ford-Evos",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Ford-Expedition",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Ford-Explorer",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Ford-F-150",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Ford-Fiesta",
        "Year Range": "2017-2019"
    },
    {
        "Car Make-Model": "Ford-Flex",
        "Year Range": "2017-2019"
    },
    {
        "Car Make-Model": "Ford-Focus",
        "Year Range": "2017-2019"
    },
    {
        "Car Make-Model": "Ford-Ford GT",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Ford-Fusion",
        "Year Range": "2017-2020"
    },
    {
        "Car Make-Model": "Ford-Maverick",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Ford-Mustang",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Ford-Mustang Mach-E",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Ford-Super Duty",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Ford-Taurus",
        "Year Range": "2017-2019"
    },
    {
        "Car Make-Model": "Ford-Transit",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Ford-Transit Connect",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "GMC-Acadia",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "GMC-Canyon",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "GMC-HUMMER EV Pickup",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "GMC-HUMMER EV SUV",
        "Year Range": "2024"
    },
    {
        "Car Make-Model": "GMC-Sierra",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "GMC-Sierra HD",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "GMC-Terrain",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "GMC-Yukon",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "GMC-Yukon XL",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Genesis-G70",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Genesis-G80",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Genesis-G90",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Genesis-GV60",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Genesis-GV70",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Genesis-GV80",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Haima-F5",
        "Year Range": "2018-2022"
    },
    {
        "Car Make-Model": "Haima-F7",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Haima-S5",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Haima-S5 Young",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Haima-S7",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Havel-F7",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Havel-H1 Blue-Brand",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Havel-H2 Blue-Brand",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Havel-H2 Red-Brand",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Havel-H6 Blue-Brand",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Havel-H6 Red-Brand",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Havel-H6N",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Havel-HAVAL DARGO",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Holden-Acadia",
        "Year Range": "2019-2020"
    },
    {
        "Car Make-Model": "Holden-Astra",
        "Year Range": "2017-2020"
    },
    {
        "Car Make-Model": "Holden-Barina",
        "Year Range": "2017-2020"
    },
    {
        "Car Make-Model": "Holden-Captiva",
        "Year Range": "2016-2020"
    },
    {
        "Car Make-Model": "Holden-Colorado",
        "Year Range": "2016-2020"
    },
    {
        "Car Make-Model": "Holden-Commodore",
        "Year Range": "2018-2020"
    },
    {
        "Car Make-Model": "Holden-Equinox",
        "Year Range": "2018-2020"
    },
    {
        "Car Make-Model": "Holden-Insignia",
        "Year Range": "2016-2018"
    },
    {
        "Car Make-Model": "Holden-Spark",
        "Year Range": "2016-2018"
    },
    {
        "Car Make-Model": "Holden-Trailblazer",
        "Year Range": "2017-2020"
    },
    {
        "Car Make-Model": "Holden-Trax",
        "Year Range": "2018-2020"
    },
    {
        "Car Make-Model": "Honda Motor-Africa Twin",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Honda Motor-Gold Wing",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Honda-Accord",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Honda-CR-V",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Honda-Civic",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Honda-Clarity",
        "Year Range": "2019-2022"
    },
    {
        "Car Make-Model": "Honda-Fit",
        "Year Range": "2018-2020"
    },
    {
        "Car Make-Model": "Honda-HR-V",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Honda-Insight",
        "Year Range": "2019-2022"
    },
    {
        "Car Make-Model": "Honda-Odyssey",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Honda-Passport",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Honda-Pilot",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Honda-Prologue",
        "Year Range": "2024"
    },
    {
        "Car Make-Model": "Honda-Ridgeline",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Hyundai-Accent",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Hyundai-Azera",
        "Year Range": "2015-2018"
    },
    {
        "Car Make-Model": "Hyundai-Bayon",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Hyundai-Casper",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Hyundai-Elantra",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Hyundai-Elantra GT",
        "Year Range": "2016-2020"
    },
    {
        "Car Make-Model": "Hyundai-Genesis Sedan",
        "Year Range": "2015-2016"
    },
    {
        "Car Make-Model": "Hyundai-IONIQ 6",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Hyundai-Ioniq",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Hyundai-Ioniq 5",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Hyundai-Kona",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Hyundai-Nexo",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Hyundai-Palisade",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Hyundai-SANTA CRUZ",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Hyundai-Santa Fe",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Hyundai-Santa Fe Sport",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Hyundai-Santa Fe XL",
        "Year Range": "2019-2020"
    },
    {
        "Car Make-Model": "Hyundai-Sonata",
        "Year Range": "2015-2023"
    },
    {
        "Car Make-Model": "Hyundai-Tucson",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Hyundai-Veloster",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Hyundai-Venue",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Hyundai-i10",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Hyundai-i30",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Hyundai-i40",
        "Year Range": "2016-2022"
    },
    {
        "Car Make-Model": "Indian-Challenger",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Indian-Chieftain",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Indian-Roadmaster",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Infiniti-Q50",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Infiniti-Q60",
        "Year Range": "2020-2022"
    },
    {
        "Car Make-Model": "Infiniti-QX50",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Infiniti-QX55",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Infiniti-QX60",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Infiniti-QX80",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Jaguar-E-Pace",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Jaguar-F-Pace",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Jaguar-F-Type",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Jaguar-I-Pace",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Jaguar-XE",
        "Year Range": "2019-2020"
    },
    {
        "Car Make-Model": "Jaguar-XF",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Jaguar-XJ",
        "Year Range": "2019"
    },
    {
        "Car Make-Model": "Jeep-Cherokee",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Jeep-Compass",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Jeep-Gladiator",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Jeep-Grand Cherokee",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Jeep-Grand Wagoneer",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Jeep-Renegade",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Jeep-Wagoneer",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Jeep-Wrangler",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "KN-Cadenza",
        "Year Range": "2017-2020"
    },
    {
        "Car Make-Model": "KN-Carnival",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "KN-EV6",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "KN-EV9",
        "Year Range": "2024"
    },
    {
        "Car Make-Model": "KN-Forte",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "KN-K5",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "KN-K8",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "KN-K900",
        "Year Range": "2019-2020"
    },
    {
        "Car Make-Model": "KN-Niro",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "KN-Optima",
        "Year Range": "2015-2020"
    },
    {
        "Car Make-Model": "KN-Optima Hybrid",
        "Year Range": "2015-2019"
    },
    {
        "Car Make-Model": "KN-Optima Plug-In Hybrid",
        "Year Range": "2017-2020"
    },
    {
        "Car Make-Model": "KN-Rio",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "KN-Sedona",
        "Year Range": "2015-2021"
    },
    {
        "Car Make-Model": "KN-Seltos",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "KN-Sorento",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "KN-Soul",
        "Year Range": "2014-2023"
    },
    {
        "Car Make-Model": "KN-Soul EV",
        "Year Range": "2015-2021"
    },
    {
        "Car Make-Model": "KN-Sportage",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "KN-Stinger",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "KN-Telluride",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "LDV-D90",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "LDV-DELIVER 9",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "LDV-EV80",
        "Year Range": "2017-2019"
    },
    {
        "Car Make-Model": "LDV-G10",
        "Year Range": "2015-2023"
    },
    {
        "Car Make-Model": "LDV-T60",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "LDV-V80",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "LDV-eDELIVER 9",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Lada-Granta",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Lada-Largus",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Lada-Vesta",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Lada-XRAY",
        "Year Range": "2021-2022"
    },
    {
        "Car Make-Model": "Lamborghini-Aventador",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Lamborghini-Centenario",
        "Year Range": "2017"
    },
    {
        "Car Make-Model": "Lamborghini-Hurac\u00e1n",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Lamborghini-Revuelto",
        "Year Range": "2024"
    },
    {
        "Car Make-Model": "Lamborghini-Urus",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Land Rover-Defender",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Land Rover-Discovery",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Land Rover-Discovery Sport",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Land Rover-Range Rover",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Land Rover-Range Rover Evoque",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Land Rover-Range Rover Sport",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Land Rover-Range Rover Velar",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Lexus-ES",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Lexus-ES Hybrid",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Lexus-GX",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Lexus-IS",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Lexus-IS 500",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Lexus-LC",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Lexus-LC Convertible",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Lexus-LC Hybrid",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Lexus-LS",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Lexus-LS Hybrid",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Lexus-NX",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Lexus-NX Hybrid",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Lexus-NX Plug\u2011in Hybrid EV",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Lexus-RC",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Lexus-RC F",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Lexus-RX",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Lexus-RX 500h",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Lexus-RX Hybrid",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Lexus-RZ 450e",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Lexus-TX",
        "Year Range": "2024"
    },
    {
        "Car Make-Model": "Lexus-UX",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Lexus-UX Hybrid",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Lifan-X70",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Lifan-X80",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Lifan-\u8f69\u6717",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Lifan-\u8fc8\u5a01",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Lincoln-Aviator",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Lincoln-Continental",
        "Year Range": "2017-2020"
    },
    {
        "Car Make-Model": "Lincoln-Corsair",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Lincoln-MKC",
        "Year Range": "2017-2018"
    },
    {
        "Car Make-Model": "Lincoln-MKS",
        "Year Range": "2017-2018"
    },
    {
        "Car Make-Model": "Lincoln-MKT",
        "Year Range": "2017-2019"
    },
    {
        "Car Make-Model": "Lincoln-MKX",
        "Year Range": "2017-2018"
    },
    {
        "Car Make-Model": "Lincoln-MKZ",
        "Year Range": "2017-2020"
    },
    {
        "Car Make-Model": "Lincoln-Nautilus",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Lincoln-Navigator",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Lotus-Eletre",
        "Year Range": "2024"
    },
    {
        "Car Make-Model": "Lotus-Emira",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Lucid-Air",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Lynk & Co-Lynk & Co 01",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "MG-Astor",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "MG-GS",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "MG-GT",
        "Year Range": "2016"
    },
    {
        "Car Make-Model": "MG-Gloster",
        "Year Range": "2020-2022"
    },
    {
        "Car Make-Model": "MG-HS",
        "Year Range": "2019-2022"
    },
    {
        "Car Make-Model": "MG-Hector",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "MG-MG",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "MG-MG Ei5",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "MG-MG3",
        "Year Range": "2020-2022"
    },
    {
        "Car Make-Model": "MG-MG4",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "MG-MG5",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "MG-Marvel R",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "MG-RX5",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "MG-ZP",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "MG-ZS",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "MG-ZS EV",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "MG-eHS",
        "Year Range": "2020-2022"
    },
    {
        "Car Make-Model": "Mahindra-Alturas G4",
        "Year Range": "2018-2022"
    },
    {
        "Car Make-Model": "Mahindra-Marazzo",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Mahindra-Scorpio",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Mahindra-Thar",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Mahindra-XUV300",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Mahindra-XUV400",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Mahindra-XUV500",
        "Year Range": "2019-2022"
    },
    {
        "Car Make-Model": "Mahindra-XUV700",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Maserati-GT Convertible",
        "Year Range": "2018-2020"
    },
    {
        "Car Make-Model": "Maserati-Ghibli",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Maserati-GranTurismo",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Maserati-Grecale",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Maserati-Levante",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Maserati-MC20",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Maserati-Quattroporte",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Maxus-D90",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Maxus-DELIVER 9",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Maxus-EV80",
        "Year Range": "2017-2019"
    },
    {
        "Car Make-Model": "Maxus-G10",
        "Year Range": "2015-2023"
    },
    {
        "Car Make-Model": "Maxus-T60",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Maxus-V80",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Maxus-eDELIVER 9",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Mazda-CX-3",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Mazda-CX-30",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Mazda-CX-5",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Mazda-CX-50",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Mazda-CX-60",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Mazda-CX-8",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Mazda-CX-9",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Mazda-CX-90",
        "Year Range": "2024"
    },
    {
        "Car Make-Model": "Mazda-MX-30",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Mazda-MX-5",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Mazda-Mazda2",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Mazda-Mazda3",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Mazda-Mazda6",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-A-Class",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-B-Class",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-C-Class",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-CLA-Class",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-CLE-Class",
        "Year Range": "2024"
    },
    {
        "Car Make-Model": "Mercedes-Benz-CLS-Class",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-E-Class",
        "Year Range": "2017-2024"
    },
    {
        "Car Make-Model": "Mercedes-Benz-E-Class Cabriolet",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-E-Class Coupe",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-EQA-Class",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-EQB-Class",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-EQC-Class",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-EQE-Class",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-EQS-Class",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-GLA-Class",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-GLB-Class",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-GLC-Class",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-GLE-Class",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-GLS-Class",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-Metris",
        "Year Range": "2020"
    },
    {
        "Car Make-Model": "Mercedes-Benz-S-Class",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-SL-Class",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Mercedes-Benz-Sprinter",
        "Year Range": "2018-2020"
    },
    {
        "Car Make-Model": "Mercedes-Benz-V-Class",
        "Year Range": "2020"
    },
    {
        "Car Make-Model": "Mercedes-Benz-Vito",
        "Year Range": "2018-2020"
    },
    {
        "Car Make-Model": "Mercedes-Benz-X-Class",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Mini-Clubman",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Mini-Convertible",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Mini-Countryman",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Mini-Hardtop 2 Door",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Mini-Hardtop 4 Door",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Mitsubishi-ASX",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Mitsubishi-Delica D:2",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Mitsubishi-Delica D:2 Custom",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Mitsubishi-Eclipse Cross",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Mitsubishi-Mirage",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Mitsubishi-Mirage G4",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Mitsubishi-Outlander",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Mitsubishi-Outlander PHEV",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Mitsubishi-Pajero",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Mitsubishi-Pajero Sport",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Mitsubishi-Triton",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Mitsubishi-Xpander",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Mitsubishi-i-MiEV",
        "Year Range": "2017"
    },
    {
        "Car Make-Model": "Nissan-Altima",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Nissan-Ariya",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Nissan-Armada",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Nissan-Frontier",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Nissan-GT-R",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Nissan-Kicks",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Nissan-Leaf",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Nissan-Maxima",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Nissan-Micra",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Nissan-Murano",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Nissan-Pathfinder",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Nissan-Patrol",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Nissan-Qashqai",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Nissan-Rogue",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Nissan-Rogue Sport",
        "Year Range": "2019-2022"
    },
    {
        "Car Make-Model": "Nissan-Sentra",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Nissan-Terrano",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Nissan-Titan",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Nissan-Versa",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Nissan-X-Trail",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Opel-ADAM",
        "Year Range": "2016-2020"
    },
    {
        "Car Make-Model": "Opel-Ampera-e",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Opel-Astra",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Opel-Combo Life",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Opel-Corsa",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Opel-Crossland X",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Opel-Grandland",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Opel-Insignia",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Opel-KARL",
        "Year Range": "2016-2020"
    },
    {
        "Car Make-Model": "Opel-Mokka",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Opel-Zafira",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Peugeot-2008",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Peugeot-208",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Peugeot-3008",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Peugeot-301",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Peugeot-308",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Peugeot-308 SW",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Peugeot-308S",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Peugeot-4008",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Peugeot-408",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Peugeot-5008",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Peugeot-508",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Peugeot-Expert",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Peugeot-Partner Tepee",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Peugeot-Rifter",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Peugeot-Traveller",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Polestar-Polestar 1",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Polestar-Polestar 2",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Porsche-718",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Porsche-911",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Porsche-Cayenne",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Porsche-Macan",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Porsche-Panamera",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Porsche-Taycan",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Qoros-Young",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Ram-Ram 1500",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Ram-Ram 2500",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Ram-Ram 3500",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Ram-Ram 4500",
        "Year Range": "2018-2022"
    },
    {
        "Car Make-Model": "Ram-Rampage",
        "Year Range": "2024"
    },
    {
        "Car Make-Model": "Renault-Alaskan",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Renault-Arkana",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Renault-Austral",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Renault-Captur",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Renault-Clio",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Renault-Duster",
        "Year Range": "2017-2021"
    },
    {
        "Car Make-Model": "Renault-Espace",
        "Year Range": "2017-2021"
    },
    {
        "Car Make-Model": "Renault-Fluence",
        "Year Range": "2017-2021"
    },
    {
        "Car Make-Model": "Renault-Grand Sc\u00e9nic",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Renault-Kadjar",
        "Year Range": "2017-2021"
    },
    {
        "Car Make-Model": "Renault-Kangoo",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Renault-Kangoo E-Tech",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Renault-Kaptur",
        "Year Range": "2020-2022"
    },
    {
        "Car Make-Model": "Renault-Kid",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Renault-Kiger",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Renault-Koleos",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Renault-Kwid E-Tech",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Renault-Master",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Renault-Megane E-Tech",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Renault-M\u00e9gane",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Renault-M\u00e9gane Estate",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Renault-Oroch",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Renault-Sandero",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Renault-Sc\u00e9nic",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Renault-Talisman",
        "Year Range": "2017-2021"
    },
    {
        "Car Make-Model": "Renault-Talisman Estate",
        "Year Range": "2017-2021"
    },
    {
        "Car Make-Model": "Renault-Traffic",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Renault-Triber",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Renault-Twingo",
        "Year Range": "2017-2020"
    },
    {
        "Car Make-Model": "Renault-Twingo E-Tech",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Renault-Zoe",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Roewe-RX3",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Roewe-RX5",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Roewe-eRX5",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Roewe-i5",
        "Year Range": "2019-2021"
    },
    {
        "Car Make-Model": "Roewe-i6",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Rolls-Royce-Cullinan",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Rolls-Royce-Dawn",
        "Year Range": "2020-2022"
    },
    {
        "Car Make-Model": "Rolls-Royce-Ghost",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Rolls-Royce-Phantom",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Rolls-Royce-Spectre",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Rolls-Royce-Wraith",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Seat-Alhambra",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Seat-Arona",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Seat-Ateca",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Seat-Ibiza",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Seat-Leon",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Seat-Tarraco",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Seat-Toledo",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Skoda-Enyaq Coup\u00e9 iV",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Skoda-Enyaq iV",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Skoda-Fabia",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Skoda-Kamiq",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Skoda-Karoq",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Skoda-Kodiaq",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Skoda-Octavia",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Skoda-Rapid",
        "Year Range": "2016-2022"
    },
    {
        "Car Make-Model": "Skoda-Scala",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Skoda-Superb",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Skoda-Yeti",
        "Year Range": "2016-2017"
    },
    {
        "Car Make-Model": "Slingshot-Slingshot",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Subaru-Ascent",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Subaru-BRZ",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Subaru-Crosstrek",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Subaru-Forester",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Subaru-Impreza",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Subaru-Legacy",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Subaru-Outback",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Subaru-Solterra",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Subaru-WRX",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Subaru-WRX STI",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Suzuki-Baleno",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Suzuki-Ciaz",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Suzuki-Dzire",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Suzuki-Hustler",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Suzuki-Ignis",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Suzuki-Jimny",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Suzuki-Lapin",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Suzuki-S-Cross",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Suzuki-SX4 S-CROSS",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Suzuki-Solio",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Suzuki-Solio Bandit",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Suzuki-Spacia",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Suzuki-Spacia Custom",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Suzuki-Swift",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Suzuki-Vitara",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "TATA-Altroz",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "TATA-Harrier",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "TATA-Hexa",
        "Year Range": "2019-2022"
    },
    {
        "Car Make-Model": "TATA-Nexon",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "TATA-Punch",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "TATA-Safari",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "TATA-Tiago",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "TATA-Tigor",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Tank-TANK 300",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Toyota-4Runner",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Toyota-86",
        "Year Range": "2020-2021"
    },
    {
        "Car Make-Model": "Toyota-Avalon",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Toyota-Avanza",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Toyota-Aygo",
        "Year Range": "2018-2022"
    },
    {
        "Car Make-Model": "Toyota-Aygo X",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Toyota-C-HR",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Toyota-Camry",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Toyota-Corolla",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Toyota-Corolla Cross",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Toyota-Corolla Hatchback",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Toyota-Crown",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Toyota-GR Corolla",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Toyota-GR Supra",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Toyota-GR86",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Toyota-Grand Highlander",
        "Year Range": "2024"
    },
    {
        "Car Make-Model": "Toyota-Highlander",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Toyota-Mirai",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Toyota-Prius",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Toyota-Prius Prime",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Toyota-RAV4",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Toyota-Sequoia",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Toyota-Sienna",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Toyota-Tacoma",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Toyota-Tundra",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Toyota-Venza",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Toyota-Voxy",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Toyota-Yaris",
        "Year Range": "2020-2023"
    },
    {
        "Car Make-Model": "Toyota-bZ4X",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Vauxhall-ADAM",
        "Year Range": "2016-2020"
    },
    {
        "Car Make-Model": "Vauxhall-Ampera-e",
        "Year Range": "2017-2022"
    },
    {
        "Car Make-Model": "Vauxhall-Astra",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Vauxhall-Corsa",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Vauxhall-Crossland-x",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Vauxhall-Grandland",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Vauxhall-Insignia",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Vauxhall-Mokka",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Vauxhall-Viva",
        "Year Range": "2016-2020"
    },
    {
        "Car Make-Model": "Vauxhall-Zafira",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Vinfast-VF8",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Vinfast-VF9",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Volkswagen-Amarok",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Arteon",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Atlas",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Beetle",
        "Year Range": "2016-2019"
    },
    {
        "Car Make-Model": "Volkswagen-Beetle Cabriolet",
        "Year Range": "2016-2019"
    },
    {
        "Car Make-Model": "Volkswagen-Bora",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Volkswagen-CC",
        "Year Range": "2016-2018"
    },
    {
        "Car Make-Model": "Volkswagen-Caddy",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-California",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Caravelle",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Crafter",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Volkswagen-CrossFox",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Fox",
        "Year Range": "2016-2019"
    },
    {
        "Car Make-Model": "Volkswagen-GTI",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Gol",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Golf",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Golf Cabriolet",
        "Year Range": "2016-2019"
    },
    {
        "Car Make-Model": "Volkswagen-Golf R",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Golf SportWagen",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Golf SportsVan",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Golf Variant",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-ID.3",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Volkswagen-ID.4",
        "Year Range": "2021-2023"
    },
    {
        "Car Make-Model": "Volkswagen-ID.5",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Volkswagen-ID.6",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Volkswagen-ID.7",
        "Year Range": "2024"
    },
    {
        "Car Make-Model": "Volkswagen-ID.Buzz",
        "Year Range": "2023"
    },
    {
        "Car Make-Model": "Volkswagen-Jetta",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Lamando",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Magotan",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Multivan",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Passat",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Passat Variant",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Polo",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Sagitar",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Saveiro",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Scirocco",
        "Year Range": "2016-2018"
    },
    {
        "Car Make-Model": "Volkswagen-Sharan",
        "Year Range": "2016-2022"
    },
    {
        "Car Make-Model": "Volkswagen-Spacefox",
        "Year Range": "2016"
    },
    {
        "Car Make-Model": "Volkswagen-T-Roc",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Talagon",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Taos",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Tiguan",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Touran",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Transporter",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "Volkswagen-Voyage",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Volkswagen-e-Golf",
        "Year Range": "2016-2020"
    },
    {
        "Car Make-Model": "Volvo-C40 Recharge",
        "Year Range": "2022-2023"
    },
    {
        "Car Make-Model": "Volvo-EX30",
        "Year Range": "2024"
    },
    {
        "Car Make-Model": "Volvo-S60",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Volvo-S90",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Volvo-V60",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Volvo-V90",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "Volvo-XC40",
        "Year Range": "2019-2023"
    },
    {
        "Car Make-Model": "Volvo-XC60",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "Volvo-XC90",
        "Year Range": "2016-2023"
    },
    {
        "Car Make-Model": "WEY-VV5",
        "Year Range": "2017-2023"
    },
    {
        "Car Make-Model": "WEY-VV6",
        "Year Range": "2018-2023"
    },
    {
        "Car Make-Model": "WEY-VV7",
        "Year Range": "2017-2023"
    }
]